import { Dimensions } from 'react-native-web';
import { MOBILE_REFERENCE_MAX_WIDTH_PX } from '../../common/constants/breakpoints';

export function vw(px: number) {
    const defaultWidth = 375;
    const width = Math.min(Dimensions.get('window').width, MOBILE_REFERENCE_MAX_WIDTH_PX);
    return (px * width) / defaultWidth;
}
